import { useEffect, useRef, useState } from "react";
import { AppCard } from "../../src/components/app-card";
import { AddAppDialog } from "../../src/components/add-app-dialog";
import { EditVersionDialog } from "../../src/components/edit-version-dialog";
import { Button } from "../../src/components/ui/button";
import { Input } from "../../src/components/ui/input";
import { Plus, Search, Package } from "lucide-react";
import { toast } from "sonner";
import { Toaster } from "../../src/components/ui/sonner";
import ModalHeaderStyle from "../utility/component/styles/modalHeader";
import { useNavigate } from "react-router-dom";
import { CallAPIPromise } from "../billing/common";
import axios from "axios";


  

export default function VersionControl() {
  const [apps, setApps] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
 const [refresh,setRefresh]=useState(false)
  const filteredApps = apps.filter((app) =>
    app.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAddApp = (newApp) => {
    setApps([...apps, newApp]);
    toast.success(`${newApp.name} has been added successfully!`);
  };

  const handleEditVersion = (app, platform) => {
    setSelectedApp(app);
    setSelectedPlatform(platform);
    setEditDialogOpen(true);
  };

  const handleSaveVersion = (
    appId,
    platform,
    data
  ) => {
  
    const platformName = platform === "ios" ? "iOS" : "Android";
    toast.success(`${platformName} version updated to ${data.version}!`);
    setRefresh(r=>!r)
  };
  const formRef = useRef(null);

  const handleViewHistory = (app) => {
    setSelectedApp(app);
    setHistoryDialogOpen(true);
  };
  const navigate = useNavigate();

  useEffect(()=>{
CallAPIPromise("/api/crossMobileAppVersion/listVersions").then((res)=>{
 if(res?.data?.data){
  setApps(res.data.data)
 }
})
  },[refresh])

  return (
    <div
    ref={formRef}
    className="w-full  flex justify-center bg-[#f5f5f7] h-full "
  >
          <div
        style={{
          padding: 0,
        }}
        className="text-sm w-full container   flex flex-col   h-full "
      >
      <Toaster />
      <div className="w-full   ">
          <ModalHeaderStyle
            header={"Version Controle"}
            onClose={() => {
                navigate("/settings");

            }}
          />
        </div>
        <div
          style={{
            height: `calc(100% - 80px)`,
          }}
          className="  rounded-b-sm bg-white w-full flex flex-col "
        >

      {/* Main Content */}
      <div className="w-ful  scroll-container overflow-y-auto l  px-4 sm:px-6 h-full lg:px-8 py-8">
      
      <Button className={'mb-3'} onClick={() => setAddDialogOpen(true)}>
              <Plus className="w-4 h-4 mr-2" />
              Add App
            </Button>
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
          <div className="bg-white rounded-lg border p-3">
            <div className="text-sm text-gray-600 mb-1">Total Apps</div>
            <div className="text-2xl font-semibold">{apps.length}</div>
          </div>
          <div className="bg-white rounded-lg border p-3">
            <div className="text-sm text-gray-600 mb-1">In Development</div>
            <div className="text-2xl font-semibold text-blue-600">
              {apps.filter((a) => a.iosStatus === "development" || a.androidStatus === "development").length}
            </div>
          </div>
          <div className="bg-white rounded-lg border p-3">
            <div className="text-sm text-gray-600 mb-1">In Testing</div>
            <div className="text-2xl font-semibold text-yellow-600">
              {apps.filter((a) => a.iosStatus === "testing" || a.androidStatus === "testing").length}
            </div>
          </div>
          <div className="bg-white rounded-lg border p-3">
            <div className="text-sm text-gray-600 mb-1">In Production</div>
            <div className="text-2xl font-semibold text-green-600">
              {apps.filter((a) => a.iosStatus === "production" && a.androidStatus === "production").length}
            </div>
          </div>
        </div>

        {/* App Grid */}
        {filteredApps.length === 0 ? (
          <div className="text-center py-12">
            <Package className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="font-medium text-gray-900 mb-2">No apps found</h3>
            <p className="text-gray-500 mb-4">
              {searchQuery ? "Try a different search term" : "Get started by adding your first app"}
            </p>
            {!searchQuery && (
              <Button onClick={() => setAddDialogOpen(true)}>
                <Plus className="w-4 h-4 mr-2" />
                Add App
              </Button>
            )}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredApps.map((app) => (
              <AppCard
                key={app.id}
                app={app}
                onEdit={handleEditVersion}
                onViewHistory={handleViewHistory}
              />
            ))}
          </div>
        )}
      </div>
      </div>

      {/* Dialogs */}
      <AddAppDialog
        open={addDialogOpen}
        onOpenChange={setAddDialogOpen}
        onAdd={handleAddApp}
      />
      <EditVersionDialog
        open={editDialogOpen}
        onOpenChange={setEditDialogOpen}
        app={selectedApp}
        platform={selectedPlatform}
        onSave={handleSaveVersion}
      />
     </div>
    </div>
  );
}
